import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/settings_/tenant-profile/modules')({
  component: lazyRouteComponent(() => import('&/features/settings/organization/pages/modules-page')),
  staticData: { titleKey: 'modules' },
});
